import { memo } from 'react';
import type { Employee } from '../../../types';

interface TaskBoxAssigneeListProps {
  assignees: Employee[];
  primaryAssignee: Employee;
  hasTeam: boolean;
  teamWeeks?: number;
  cardWidth: number;
}

export const TaskBoxAssigneeList = memo(function TaskBoxAssigneeList({
  assignees,
  primaryAssignee,
  hasTeam,
  teamWeeks,
  cardWidth,
}: TaskBoxAssigneeListProps) {
  const showExpanded = cardWidth > assignees.length * 80;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0, overflow: 'hidden' }}>
      {showExpanded ? (
        assignees.map((emp, idx) => (
          <span
            key={emp.id}
            style={{
              fontSize: 9,
              opacity: 0.9,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              whiteSpace: 'nowrap',
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                backgroundColor: emp.color,
                flexShrink: 0,
                border: '1px solid rgba(255,255,255,0.5)',
              }}
            />
            {emp.name}
            {idx < assignees.length - 1 && ','}
          </span>
        ))
      ) : (
        <span
          style={{
            fontSize: 9,
            opacity: 0.9,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {hasTeam
            ? `${primaryAssignee.name} +${assignees.length - 1}`
            : primaryAssignee.name}
        </span>
      )}
      {hasTeam && teamWeeks && (
        <span
          style={{
            fontSize: 9,
            backgroundColor: '#22c55e',
            padding: '1px 4px',
            borderRadius: 3,
            flexShrink: 0,
          }}
        >
          {teamWeeks.toFixed(1)}w
        </span>
      )}
    </div>
  );
});
